import { Type } from "@sinclair/typebox";
import { Nullable, NullableNumber, NullableString } from "../../utils/typeboxTypes";
export const MsgrConversationStatusSchema = Type.Union([Type.Literal("started"), Type.Literal("complete")], {
    default: "started",
});
export const MsgrConversationSchema = Type.Object({
    id: Type.Number(),
    uid: Type.String({ maxLength: 50 }),
    status: MsgrConversationStatusSchema,
    completed_at: Nullable(Type.Date()),
    completed_by: NullableString,
    agent_joined_at: Nullable(Type.Date()),
    agent_id: NullableNumber,
    created_at: Nullable(Type.Date({ default: () => new Date() })),
    updated_at: Nullable(Type.Date({ default: () => new Date() })),
    deleted_at: Nullable(Type.Date({ default: () => null })),
});
// 1	id	bigint(20)	NULL	NULL	NO	NULL	auto_increment
// 2	uid	varchar(50)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 3	status	varchar(255)	utf8mb4	utf8mb4_unicode_ci	NO	started
// 4	completed_at	datetime	NULL	NULL	YES	NULL
// 5	completed_by	varchar(255)	utf8mb4	utf8mb4_unicode_ci	YES	NULL
// 6	agent_joined_at	datetime	NULL	NULL	YES	NULL
// 7	agent_id	bigint(20)	NULL	NULL	YES	NULL		people(id)
// 8	created_at	timestamp	NULL	NULL	YES	NULL
// 9	updated_at	timestamp	NULL	NULL	YES	NULL
// 10	deleted_at	timestamp	NULL	NULL	YES	NULL
